import { useTranslation } from 'react-i18next';
import { RevealItem } from 'shared/components/RevealItem/RevealItem';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';
import { HostCard } from '../components/HostCard/HostCard';
import { HOSTS } from "../hosts";

export const MeetTheHostsSection = () => {
  const { t } = useTranslation('about');
  const heading = useScrollReveal({ animation: 'float-up' });

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 mb-16 md:mb-32">
      <div ref={heading.ref} style={heading.style} className="text-center mb-10 md:mb-20">
        <span className="font-sans uppercase tracking-[0.3em] text-tertiary text-xs font-bold mb-4 block">
          {t('hosts.label')}
        </span>
        <h2 className="font-serif text-5xl italic">{t('hosts.heading')}</h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {HOSTS.map((host, i) => (
          <RevealItem key={host.name} index={i} className={i === 1 ? 'lg:mt-12' : ''}>
            <HostCard {...host} />
          </RevealItem>
        ))}
      </div>
    </section>
  )
}
